import Header from "../Components/Header.jsx";
import Footer from "../Components/Footer.jsx";
import { FaAngleRight } from "react-icons/fa6";
import { HeartFilled, EyeFilled } from "@ant-design/icons";
import { PortfolioData } from "../Data/PortfolioData.js";
import "../Css/Pages/Portfolio.css";

const Portfolio = () => {
  return (
    <>
      <Header />
      <div className="portfolyo-page-header">
        <div className="portfolyo-page-title">
          <h1>Çalışmalarım</h1>
        </div>
        <div className="portfolyo-page-breadcrumb">
          <a href="/">Anasayfa</a>
          <FaAngleRight className="portfolyo-page-breadcrumb-icon" />
          <strong>Çalışmalarım</strong>
        </div>
      </div>
      <div className="portfolio-page-content-container">
        {PortfolioData.map((product) => (
          <div className="portfolio-page">
            <a
              href={"/PortfolioDetail/" + product.id}
              className="portfolio-page-link"
            >
              <img
                src={product.image}
                alt=""
                className="portfolio-page-image"
              />
            </a>
            <div className="portfolio-page-wrapper">
              <a
                href={"/PortfolioDetail/" + product.id}
                className="portfolio-page-wrapper-link"
              >
                <div className="portfolio-page-details">
                  <strong className="portfolio-page-name">
                    {product.title}
                  </strong>
                  <span className="portfolio-page-category">Web Site</span>
                </div>
              </a>
              <div className="portfolio-page-icons-container">
                <div className="portfolio-page-icons-heart">
                  <span className="portfolio-page-icons-heart-link">
                    <HeartFilled className="portfolio-page-icon " />
                  </span>
                  <span className="portfolio-page-icon-text">1</span>
                </div>
                <div className="portfolio-page-icons-eye">
                  <EyeFilled className="portfolio-page-icon" />
                  <span className="portfolio-page-icon-text">1</span>
                </div>
              </div>
            </div>
          </div>
        ))}
      </div>
      <Footer />
    </>
  );
};

export default Portfolio;
